import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, ChevronRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Persistent banner for logged-in users who haven't yet verified their email.
 * Hidden on the /verify-email and /login pages themselves to avoid noise.
 * Placement: mount once, high in the tree, right below the Header.
 */
const VerifyEmailBanner = () => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  const HIDE_ON = ['/verify-email', '/login', '/register', '/forgot-password', '/reset-password'];
  if (!isAuthenticated || !user) return null;
  if (user.email_verified) return null;
  if (HIDE_ON.some(path => location.pathname.startsWith(path))) return null;

  return (
    <Link
      to={`/verify-email?email=${encodeURIComponent(user.email)}`}
      className="block bg-[#c9a961]/15 border-b border-[#c9a961]/30 hover:bg-[#c9a961]/25 transition-colors"
      data-testid="verify-email-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-2 text-sm">
        <Mail className="w-4 h-4 text-[#a8873f]" strokeWidth={1.75} />
        <span className="text-stone-800">
          Verify your email <span className="font-medium">({user.email})</span> to complete orders and unlock loyalty rewards.
        </span>
        <span className="hidden sm:inline-flex items-center gap-1 font-medium text-[#a8873f]">
          Enter code <ChevronRight className="w-4 h-4" />
        </span>
      </div>
    </Link>
  );
};

export default VerifyEmailBanner;
